import NavLogo from "./NavLogo";
import NavLinks from "./NavLinks";
import ThemeToggle from "./ThemeToggle";
import { ArrowUpRightIcon } from "../Icons";
import { useSettings } from "../../data/content";

function Navbar({ darkMode, toggleDarkMode, onSayHi }) {
  const settings = useSettings();

  return (
    <header className="fixed top-3 md:top-6 left-0 right-0 z-50 flex justify-center px-4">
      <nav className="flex items-center gap-1 px-2 py-1.5 md:py-2 rounded-full bg-surface-light dark:bg-surface-dark border border-border-light dark:border-border-dark shadow-sm">
        <NavLogo />
        <NavLinks />
        <button
          onClick={onSayHi}
          className="ml-1 px-3 py-1.5 font-sans text-sm text-text-muted-light dark:text-text-muted-dark hover:text-text-primary-light dark:hover:text-text-primary-dark transition-colors flex items-center gap-1"
        >
          {settings.navCTA} <ArrowUpRightIcon size={14} />
        </button>
        <div className="w-px h-4 bg-border-light dark:bg-border-dark mx-1" />
        <ThemeToggle darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      </nav>
    </header>
  );
}

export default Navbar;
